export default "__VITE_ASSET__N6mX4jVZ__"